module.exports = __webpack_public_path__ + "img/konvert-green.8a45db81.svg";